/**
 * LE REPLAY SUR LA ROUTE DU COMPTEUR (DEV-1508 lot 2, contrat v1.0 §3.2).
 * ============================================================================
 *
 * INTENTION : voir une friction, pas seulement la compter. Le contrat demande
 * l'échantillonnage des sessions à 20 % SUR CETTE ROUTE pendant trente jours, le
 * reste de l'application restant à 5 % (`loadApp.ts`), le replay sur erreur
 * restant à 100 %.
 *
 * Comment, sans toucher au réglage global : le replay est déjà chargé par
 * `Sentry.replayIntegration()`, avec le masquage total du texte et le blocage des
 * médias. À l'entrée de la route, on tire à 20 % et on DÉMARRE l'enregistrement
 * pour cette session. Sortir de la route ne l'arrête pas : une session enregistrée
 * l'est jusqu'au bout, c'est le comportement de Sentry, pas une décision d'ici.
 *
 * Deux gardes :
 *  • tout est encadré : sans Sentry, sans replay, ou sur une erreur d'intégration,
 *    la page vit exactement pareil. Le suivi ne casse jamais l'écran ;
 *  • on ne démarre qu'UNE fois par session : rappeler la fonction en changeant
 *    d'onglet ne relance rien.
 */
import * as Sentry from "@sentry/vue"

/** Part des sessions enregistrées sur cette route (contrat §3.2). */
export const PART_REPLAY_COMPTEUR = 0.2

let dejaDemarre = false

/** Remet le garde à zéro. Réservé aux tests. */
export function reinitialiserReplayCompteur(): void {
    dejaDemarre = false
}

/**
 * Démarre le replay pour cette session avec la probabilité du contrat.
 *
 * @param tirage - le tirage au sort, injectable pour les tests
 * @returns `true` si l'enregistrement vient d'être demandé, `false` sinon
 */
export function demarrerReplaySurLaRoute(
    tirage: () => number = Math.random
): boolean {
    if (dejaDemarre) return false
    try {
        if (tirage() >= PART_REPLAY_COMPTEUR) return false
        const replay = Sentry.getReplay?.()
        if (!replay) return false
        dejaDemarre = true
        replay.start()
        return true
    } catch {
        // Sans replay, la page ne change pas d'un pixel.
        return false
    }
}
